export enum ImportactionTypes {
    API_RESPONSE_SUCCESS = '@@import/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@import/API_RESPONSE_ERROR',

    IMPORT_ALL = '@@import/IMPORT_ALL',
    RESET = '@@import/RESET',
    RESET_SUCCESS = '@@import/RESET_SUCCESS',
    RESET_ERROR = '@@import/RESET_ERROR',
}
